import { Button, Text, Flex, Box, Icon } from '@chakra-ui/react';
import { PanelCardErrorContainer } from './style';
import { WarningTwoIcon } from '@chakra-ui/icons';

interface ErrorProps {
  onRefreshClick: () => void;
  errorMessage?: string;
  title?: string;
}

export default function Error({ onRefreshClick, errorMessage, title }: ErrorProps) {
  return (
    <PanelCardErrorContainer>
      <Flex
        direction="column"
        align="center"
        justify="center"
        p={2.5}
        bg="primary.100"
        borderRadius="md"
        borderLeft="2px solid"
        borderColor="brand.blue"
        textAlign="center"
        width="100%"
        height="100%"
        mx="auto"
      >
        <Icon as={WarningTwoIcon} w={5} h={5} color="brand.blue" mb={1.25} />

        <Text fontSize="md" fontWeight="semibold" mb={4} color="brand.blue">
          {title || 'Chart Loading Error'}
        </Text>

        <Text fontSize="xs" color="secondary.700" mb={4} maxWidth="300px" noOfLines={3}>
          {errorMessage || (
            <>
              We encountered an issue loading the visualization.
              <br />
              Please try refreshing or check your network connection.
            </>
          )}
        </Text>

        <Button
          size="sm"
          colorScheme="blue"
          variant="solid"
          onClick={onRefreshClick}
          leftIcon={<Icon as={WarningTwoIcon} boxSize={3.5} />}
          _hover={{ bg: 'primary.900' }}
          px={4}
          py={1.5}
          mt={4}
          fontSize="0.875rem"
        >
          Retry Loading Chart
        </Button>
      </Flex>
    </PanelCardErrorContainer>
  );
}
